(function(){
	const modal = document.querySelector('.popup-modal-d5');
	const accordions = document.querySelectorAll('.product-about__accordion-title');
	accordions.forEach(acc => {
		acc.addEventListener('click', () => {
			if(acc.classList.contains('open-drawer-d5')){
				const sHeader = document.querySelector('.shopify-section-header');
      if(sHeader) sHeader.classList.remove('shopify-section-header-sticky');
				document.body.classList.add('overflow-hidden');
				const content = acc.closest('.product-about__accordion-item')?.querySelector('.product-about__accordion-description');
				if (content) {
				modal.classList.add('active');
				modal.querySelector('.popup-content-d5').innerHTML = ''
				modal.querySelector('.popup-content-d5').innerHTML = `
					<div class="product-about__accordion-description rte rte__container product-about__accordion-content main-product-description small-font">
					${content.innerHTML}
					</div>
				`;
				}
			}else{
					const content = acc.closest('.product-about__accordion-item')
                   .querySelector('.product-about__accordion-description');

if (!acc.classList.contains('active')) {
    acc.classList.add('active');
	content.classList.add('active');
    content.style.display = 'block';
    content.style.height = 'auto';
    const height = content.offsetHeight + "px";
    content.style.height = '0';
    content.offsetHeight;
    content.style.transition = 'height 0.3s ease';
    content.style.height = height;
} else {
    acc.classList.remove('active');
    content.style.transition = 'height 0.3s ease';
    content.style.height = '0';
	content.classList.remove('active');
}
				}
		})
	})
	document.addEventListener('click', (e) => {
		if(e.target.classList.contains('acc__close')){
			modal.classList.remove('active');
			document.body.classList.remove('overflow-hidden');
		}
	})
})()